// @flow
import qs from 'query-string';
import type {Location} from 'react-router-dom';

export type QueriesObject = {[_: string]: string | null | string[]};

export const getQueriesObjectFromLocation = ({
  location,
}: {
  location: Location,
}): QueriesObject => {
  return location.search ? qs.parse(location.search) : {};
};

export const createQueryStringFromObject = (inputArgs: {
  [key: string]: string,
}): string => {
  const queryStrings = Object.keys(inputArgs).reduce(
    (accumulator, key, index) => {
      if (inputArgs[key] && typeof inputArgs[key] === 'string') {
        accumulator += `${key}=${encodeURIComponent(inputArgs[key])}&`;
      }
      if (
        index === Object.keys(inputArgs).length - 1 &&
        accumulator[accumulator.length - 1] === '&'
      ) {
        accumulator = accumulator.slice(0, -1);
      }
      return accumulator;
    },
    '',
  );
  return queryStrings;
};

// extract query string values from location, make a guarantee that the returned value is objects of strings

export const extractQueryStringValuesFromLocation = (inputArgs: {
  location: Location,
  keysToExtract: string[],
}): {[_: string]: string} => {
  let {location, keysToExtract} = inputArgs;
  let queries = getQueriesObjectFromLocation({location});

  return keysToExtract.reduce((accumulator, key, index) => {
    accumulator[key] =
      (typeof queries === 'object' &&
        Object.keys(queries).includes(key) &&
        typeof queries[key] === 'string' &&
        encodeURIComponent(queries[key])) ||
      '';
    return accumulator;
  }, {});
};
